
<ng-container *ngIf="link$ | async as link">
	<ng-container *ngIf="linkInfo$ | async as linkInfo">
		<al-link-header [linkInfo]="linkInfo" [link]="link"></al-link-header>
		<div class="card">
			<div class="card-body">
				<al-link-edit [linkInfo]="linkInfo" [link]="link" [routeQueryParams]="routeQueryParams$ | async"></al-link-edit>
			</div>
		</div>
	</ng-container>
</ng-container>
